import { render, staticRenderFns } from "./DeathPenaltyLaw.vue?vue&type=template&id=4a840870&scoped=true"
import script from "./DeathPenaltyLaw.vue?vue&type=script&lang=js"
export * from "./DeathPenaltyLaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a840870",
  null
  
)

export default component.exports